'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { trpc } from '@/app/_trpc/client';

import { ProfilePhotoUploader } from '@/components/features/ProfilePhotoUploader';
import Icon, { IconName } from '@/components/ui/Icon';
import { useSidebar } from '@/components/ui/sidebar';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
export default function MenuAvatar({
  size = 110,
  userId,
  className,
}: {
  size?: number;
  userId: string;
  className?: string;
}) {
  const router = useRouter();
  const t = useTranslations('menu');
  const { setOpenMobile } = useSidebar();

  const [user] = trpc.users.getById.useSuspenseQuery({
    id: userId as string,
  });

  const menuAvatarSkeleton = (
    <>
      <Skeleton
        style={{ width: size, height: size }}
        className='rounded-full'
      />
      <div className='mt-2 flex items-center gap-1'>
        <Skeleton className='h-4 w-4' />
        <Skeleton className='h-7 w-32' />
      </div>
      <Skeleton className='mt-1 h-5 w-20' />
    </>
  );

  return (
    <div
      className={cn('mb-8 flex items-center gap-2 md:mt-6 md:mb-10', className)}
    >
      {!user ? (
        menuAvatarSkeleton
      ) : (
        <>
          <ProfilePhotoUploader
            photoUrl={user.profile.profilePhoto || null}
            size={size}
          />

          <div className='flex flex-col md:items-center'>
            <div className='flex items-center gap-1'>
              {user?.idVerificationStatus && (
                <Icon variant={IconName.PatchCheckOn} />
              )}
              <Link
                href={`/profile/${user?.id}`}
                onClick={() => setOpenMobile(false)}
              >
                <h2 className='text-lg font-medium capitalize'>{user?.name}</h2>
              </Link>
            </div>

            {!user?.idVerificationStatus && (
              <button
                onClick={() => {
                  router.push('/verify-user');
                  setOpenMobile(false);
                }}
                className='cursor-pointer leading-3'
              >
                <span className='bg-destructive-400 text-2xs rounded-[10px] px-[5px] py-0.5 font-semibold text-white uppercase'>
                  {t('not-verified')}
                </span>
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
